module.exports = __webpack_public_path__ + "img/shop.b6e9635d.png";